module.exports = __webpack_public_path__ + "h5/img/red-packets.6a5bac43.png";